import {Link} from "react-router-dom";
import React, {Fragment, useEffect, useState} from "react";
import {getParams, useOuterClick} from "../../utils/hooks/getParams";
import {getClientsTransactions, getClientTransactions, updateTransaction} from "../../actions/client";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment/moment";
import ClientDataCell from "./SupplierMaterialDataCell";
import {formatMoney, unformatMoney} from "../../utils/hooks/getParams";
import {getSupplierTransactions} from "../../actions/supplier";
import SupplierMaterialDataCell from "./SupplierMaterialDataCell";

const SupplierMaterialDataRow = ({index, item, resetAllRows}) => {
    const dispatch = useDispatch();

    const {
        auth
    } = useSelector(state => state);
    const {role_name} = auth?.user || {};

    const [itemData, setItemData] = useState({
        material_transactions: []
    });
    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        setItemData(item);
    }, [item])

    useEffect(() => {
        if (item.hasOwnProperty('material_transactions')) {
            setRowData(itemData.material_transactions);
        }
    }, [itemData]);

    const refreshRow = (id) => {
        dispatch(getSupplierTransactions(id));
    }


    return (
        <tr>
            <th className="sticky-col">{index + 1}</th>
            <th className="sticky-col2">
                <Link to={`suppliers/${item.id}`}>
                    {item.name}
                </Link>
            </th>
            {
                rowData.map((subitem, subindex) => (
                    <SupplierMaterialDataCell
                        rowData={rowData}
                        key={subindex}
                        row_id={itemData.id}
                        item={subitem}
                        cellItem={subitem}
                        index={subindex}
                        setItemData={setItemData}
                        setRowData={setRowData}
                        refreshRow={refreshRow}
                        resetAllRows={() => console.log(2)}
                    />))
            }
            <th style={{textAlign: "center", minWidth: "100px", right: "300px"}}
                title={formatMoney(itemData.prev_month_left_amount)}
            >
                {formatMoney(itemData.prev_month_left_amount?.toFixed(2))}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "200px"}}
                title={formatMoney(itemData.material_transactions_sum_received_amount, ',')}
            >
                {formatMoney(itemData.material_transactions_sum_received_amount?.toFixed(2), ',')}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "100px"}}
                title={formatMoney(itemData.material_transactions_sum_spent_amount, ',')}
            >
                {formatMoney(itemData.material_transactions_sum_spent_amount?.toFixed(2), ',')}
            </th>
            <th style={{textAlign: "center", minWidth: "100px", right: "0px"}}
                title={formatMoney(itemData.current_month_left_amount, ',')}
            >
                {formatMoney(itemData.current_month_left_amount?.toFixed(2))}
            </th>
        </tr>
    )
}

export default SupplierMaterialDataRow;